import { useState, useEffect } from 'react';

const useAudioPlayer = () => {
  const [volume, setVolume] = useState(0.1);
  const [isMuted, setIsMuted] = useState(true);

  useEffect(() => {
    const audio = document.getElementById('audio') as HTMLAudioElement;
    if (!audio) {
      return;
    }

    if (isMuted) {
      audio.pause();
    } else {
      audio.play();
    }
    audio.volume = volume;
  }, [volume, isMuted]);

  return {
    volume,
    setVolume,
    isMuted,
    setIsMuted,
  };
};

export default useAudioPlayer;
